<template>
  <div class="voucher-redeem"
    v-loading="redeeming"
    element-loading-background="rgba(255, 255, 255, 0.6)">
    <h5>Redeem Voucher</h5>
    <el-form label-position="left" label-width="120px" :model="form" :rules="formRules" ref="form">
      <el-form-item label="User" prop="user_id">
        <el-select
          v-model="form.user_id"
          filterable
          remote
          :remote-method="findUsers"
          placeholder="Search by user name or email"
          :loading="loading"
          clearable>
          <el-option
            v-for="user in findings"
            :key="user.id"
            :value="user.id"
            :label="`${user.user_name} (${user.email})`" />
        </el-select>
      </el-form-item>
      <el-form-item label="Stage" prop="stage">
        <el-select v-model="form.stage">
          <el-option value="live" label="live" />
          <el-option value="beta" label="beta" />
          <el-option value="dev" label="dev" />
        </el-select>
      </el-form-item>
      <el-form-item label="Code" prop="code">
        <el-input v-model="form.code" />
      </el-form-item>
      <el-form-item label-width="120px">
        <el-button type="primary" @click="redeem">Redeem</el-button>
        <el-button @click="reset">Reset</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped>
  .voucher-redeem {
    margin-top: 20px;
    background: #EFF2F7;
    padding: 20px;
  }

  .el-input, .el-select {
    width: 60%;
  }

  @media only screen and (max-width : 992px) {
    .el-input, .el-select {
      width: 100%;
    }
  }
</style>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data () {
    return {
      form: {
        user_id: null,
        code: null
      },
      formRules: {
        user_id: [
          { required: true, message: 'Please select User', trigger: 'change' }
        ],
        code: [
          { required: true, message: 'Please input Code', trigger: 'blur' }
        ]
      },
      redeeming: false,
      findings: [],
      loading: false
    }
  },

  computed: {
    ...mapGetters('users', {
      users: 'all'
    })
  },

  methods: {
    ...mapActions('users', {
      fetchUsers: 'fetchAll'
    }),
    ...mapActions('vouchers', ['redeemVoucher']),
    redeem () {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            this.redeeming = true
            await this.redeemVoucher({ ...this.form })
            const user = this.users.find(u => this.form.user_id === u.id)
            this.$message({
              type: 'success',
              message: `Voucher successfully redeemed on behalf of ${user.user_name}`
            })
            this.reset()
          } catch (error) {
            this.$message({
              type: 'error',
              message: error.message
            })
          } finally {
            this.redeeming = false
          }
        }
      })
    },
    reset () {
      this.$refs['form'].resetFields()
    },
    findUsers (name) {
      if (name.length > 1) { // min 2 chars
        this.loading = true
        this.findings = this.users.filter(user => {
          const term = name.toLowerCase()
          return user.email.toLowerCase().indexOf(term) > -1 || user.user_name.toLowerCase().indexOf(term) > -1
        })
        this.loading = false
      } else {
        this.findings = []
      }
    }
  },

  mounted () {
    if (this.users.length === 0) {
      this.fetchUsers()
    }
  }
}
</script>





// WEBPACK FOOTER //
// src/components/vouchers/VoucherRedeem.vue